import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'relativeDay',
  pure: false
})
export class RelativeDayPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: Date | string, format: string = 'DD-MMM-YYYY, hh:mm A'): string {
    if (!value) return '';

    const input = moment(value);
    const date = input.clone().startOf('day');
    const today = moment().startOf('day');
    const tomorrow = moment().add(1, 'day').startOf('day');
    const yesterday = moment().subtract(1, 'day').startOf('day');

    const timePart = input.format('hh:mm A');

    if (date.isSame(today)) {
      return `${this.translate.instant('todayLbl')}, ${timePart}`;
    } else if (date.isSame(tomorrow)) {
      return `${this.translate.instant('COMMON.TOMORROW')}, ${timePart}`;
    } else if (date.isSame(yesterday)) {
      return `${this.translate.instant('yesterdayLbl')}, ${timePart}`;
    } else {
      return input.format(format);
    }
  }
}
